import { useState , useEffect  } from 'react';
import styles from './AdminLogin.module.css';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../AdminAuthContext';
import axios from 'axios';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { adminLogin } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("adminAccessToken");
    delete axios.defaults.headers.common['Authorization'];
    console.log("[AdminLogin] Cleared old token");
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("[AdminLogin] Submit triggered");
    setError(''); 
  
    try {
      await adminLogin(email, password);
      navigate('/admin/dashboard');
      console.log("[AdminLogin] Login passed to context");
    } catch (err) {
      console.error("Login error:", err);
      if (err.response && err.response.status === 403) {
        setError('Unauthorized. Please logout your user account first.');
      } else {
        setError('Invalid email or password. Please try again.');
      }
    }
  };

  return (
    <div className={styles.pageBackground}>
      <div className={styles.loginContainer}>
        <h2 className={styles.loginTitle}>Login</h2>
        <form onSubmit={handleLogin} className={styles.form}>
          <label className={styles.label}>Email</label>
          <input
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={styles.input}
          />
          <label className={styles.label}>Password</label>
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={styles.input}
          />
          <button type="submit" disabled={isLoading} className={styles.button}>
            {isLoading ? 'Logging in...' : 'Log In'}
          </button>
          {error && <p className={styles.error}>{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
